import { segmentGroupAnatomy } from "@chakra-ui/react/anatomy";
import { defineSlotRecipe } from "@chakra-ui/react/styled-system";

export default defineSlotRecipe({
  slots: segmentGroupAnatomy.keys(),
  base: {
    root: {
      "--segment-radius": "radii.xl",
      minW: "max-content",
    },
  },
});
